import { gql } from "@apollo/client";

export const DELETE_ORGANIZATION = gql`
  mutation DeleteOrganization($orgMrn: ID!) {
    deleteOrganization(orgMrn: $orgMrn)
  }
`;
